module.exports = __webpack_public_path__ + "1b97a2fa46f03896d1b463670f187479.MP3";